export default "__VITE_ASSET__BEo_vSMk__"